import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, X } from 'lucide-react';
import { Button } from '../ui/button';
import { getPromoBanner } from '../../services/banners';

const PromoBanner = () => {
  const [banner, setBanner] = useState(null);
  const [dismissed, setDismissed] = useState(() => {
    return localStorage.getItem('promoBannerDismissed') === 'true';
  });

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const promoBanner = await getPromoBanner();
        setBanner(promoBanner);
      } catch (error) {
        console.error('Error fetching promo banner:', error);
      }
    };
    fetchBanner();
  }, []);

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem('promoBannerDismissed', 'true');
  };

  if (dismissed || !banner) {
    return null;
  }

  return (
    <section className="py-5 sm:py-7">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-2xl bg-[#1a1a2e]">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-600" />
          </div>
          
          <div className="relative px-8 py-16 sm:px-16 sm:py-20 text-center">
            <button
              onClick={handleDismiss}
              className="absolute top-4 right-4 text-white/70 hover:text-white transition-colors"
              aria-label="Dismiss banner"
            >
              <X size={20} />
            </button>
            {banner.subtitle && (
              <span className="inline-block text-blue-400 text-sm font-medium tracking-wider uppercase mb-4">
                {banner.subtitle}
              </span>
            )}
            <h2 className="text-white text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
              {banner.title || 'Özel Fırsatlar'}
            </h2>
            {banner.description && (
              <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto">
                {banner.description}
              </p>
            )}
            {banner.link && (
              <Link to={banner.link}>
                <Button
                  size="lg"
                  className="bg-white text-[#1a1a2e] hover:bg-gray-100 text-base px-8"
                >
                  {banner.cta || 'Alışverişe Başla'}
                  <ArrowRight size={18} className="ml-2" />
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromoBanner;
